import SurveysTooltip from './SurveysTooltip';

export default SurveysTooltip;
